/**
 * Primary conversion target for every activation CTA. Routes to the shared
 * contact dialog through the existing `#waitlist` hash on every deployment.
 */
export const WAITLIST_HREF = "#waitlist";
export const NEWSLETTER_HREF = "#newsletter";
export const PARTNER_HREF = "https://go.mlx.systems/partners";
